import { UKBoundaryNames } from "./UK";
import { USBoundaryNames } from "./US";

export {
  UKBoundaryNames,
  USBoundaryNames
}
